//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import RemoveIcon from "@material-ui/icons/Delete";
import * as Utils from "eai-configurator-ui/components/Utils";
import Tooltip from "@material-ui/core/Tooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  table: {
    minWidth: 300,
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  title: {
    flex: "1 1 100%",
  },
}));

export default function DataSourcesTable({
  setAlertMessage,
  refreshCounter,
  handleEditDataSource,
  handleRemoveDataSource,
}) {
  const classes = useStyles();
  const [dataSources, setDataSources] = React.useState([]);

  React.useEffect(() => {
    populateTable();
  }, [refreshCounter]);

  const populateTable = () => {
    Utils.fetchData("loader/dataSources")
      .then((data) => {
        setDataSources(data.dataSources);
      })
      .catch(function (response) {
        Utils.getErrorMessage(response, "Failed to fetch companies.").then(
          (message) =>
            setAlertMessage({
              success: false,
              message: message,
            })
        );
      });
  };

  const isTableEmpty = dataSources.length === 0;
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Toolbar className={clsx(classes.toolbar)}>
          <Typography className={classes.title} variant="h6" id="tableTitle">
            Data Sources
          </Typography>
        </Toolbar>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="data-sources">
            {!isTableEmpty && (
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell align="center">Type</TableCell>
                  <TableCell align="center">URL</TableCell>
                  <TableCell align="center">Username</TableCell>
                </TableRow>
              </TableHead>
            )}
            <TableBody>
              {dataSources.map((dataSource, index) => (
                <TableRow key={index} hover role="task" tabIndex={-1}>
                  <TableCell
                    align="left"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {dataSource.name}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {dataSource.type}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {dataSource.url}
                  </TableCell>
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    {dataSource.username}
                  </TableCell>
                  <TableCell
                    align="right"
                    component="th"
                    scope="row"
                    padding="default"
                  >
                    <Tooltip title="Edit Data Source">
                      <IconButton
                        onClick={() => {
                          handleEditDataSource(dataSource);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Data Source">
                      <IconButton
                        onClick={() => {
                          handleRemoveDataSource(dataSource);
                        }}
                      >
                        <RemoveIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
              {isTableEmpty && (
                <TableRow style={{ height: 53 }}>
                  <TableCell>
                    <Typography align="center" color="textSecondary">
                      No data sources
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}
